import { Header } from 'antd/lib/layout/layout';
import useTranslate from '@core/hooks/useTranslate';
import PageTop from '@root/modules/Sellers/Dashboard/components/PageTop';
import { useHistory, useParams } from 'react-router-dom';
import ProductService from '../../Product/services/product';
import { Card, Typography, Table, Button } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import StockServices from '@root/modules/Sellers/Stock/services/stock';
import moment from 'moment';
import { useEffect, useState } from 'react';
import DetailsPro from '@root/modules/Warehouse/Inquiry/components/details-pro';
import InfoProduct from '../../Product/components/InfoProduct';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import BreadcrumbList from '../components/Breadcrumb';
import { formatDateTime } from '@root/utils/helpers/formatDate';

interface DataType {
  no: number;
  status: string;
  quantity: number;
  updated_at: Date;
}

const Breadcrumb = [
  {
    tittle: '재고 관리',
    url: '/admin/seller/stock'
  },
  {
    tittle: '물류센터 조회',
    url: '/admin/seller/stock'
  }
];

const { Text } = Typography;

const StockDetail = () => {
  const [product, setProduct] = useState({} as any);
  const [info, setInfo] = useState<{
    completedDate: string | Date;
    quantity: number;
  }>({ completedDate: '22/09/2022', quantity: 0 });
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([] as any);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [sort, setSort] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const history = useHistory();

  const [t] = useTranslate();

  const { productId }: any = useParams();

  const [breadcrumb, setBreadcrumb] = useState<
    { tittle: string; url: string }[]
  >([
    {
      tittle: '재고 관리',
      url: '/admin/seller/stock'
    },
    {
      tittle: '물류센터 조회',
      url: '/admin/seller/stock'
    }
  ]);

  const getDetail = async () => {
    const detailProduct = await ProductService.getDetailProduct(productId);
    detailProduct.data.updated_at =
      //  moment(detailProduct.data.updated_at)
      //   .utc(true ?? 9)
      //   .format('YYYY-MM-DD hh:mm:ss A ');
      formatDateTime(detailProduct.data.updated_at);
    setProduct(detailProduct.data);
    setInfo({
      completedDate: detailProduct.data?.updated_at,
      quantity: detailProduct.data?.inventory?.remainQuantity ?? 0
    });
    setBreadcrumb((item) => [
      ...item,
      ...[
        {
          tittle: detailProduct?.data?.quotation?.warehouse?.name ?? 'dev',
          url: detailProduct?.data?.quotation?.warehouse?.id
            ? `/admin/seller/stock/${detailProduct.data.quotation.warehouse.id}`
            : ''
        },
        {
          tittle: detailProduct.data.productName,
          url: ''
        }
      ]
    ]);
  };

  const columns: ColumnsType<DataType> = [
    {
      title: '주문번호',
      dataIndex: 'orderNumber'
    },
    {
      title: '수량',
      dataIndex: 'quantity'
    },

    {
      title: '상태',
      dataIndex: 'status'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {t('table:seller:update')}
          {!sort ? (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(true);
              }}
            />
          ) : (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => setSort(false)}
            />
          )}
        </div>
      ),
      dataIndex: 'updated_at'
      // key: "updated_at",
    }
  ];
  const getPagination = async (id: number, page: number, sort: boolean) => {
    setLoading(true);
    const detailProduct = await StockServices.getPaginationOrder({
      id,
      page,
      sort
    });
    const listProduct =
      detailProduct.data.data.length > 0
        ? detailProduct.data.data.map((item: any) => ({
            ...item,
            // updated_at: moment(item.updated_at)
            //   .utc(true ?? 9)
            //   .format('YYYY-MM-DD hh:mm:ss A '),
            updated_at: formatDateTime(item.updated_at),
            quantity: item?.orderProducts[0].orderQuantity
          }))
        : [];
    setList(listProduct);
    setTotalItems(detailProduct.data.meta.totalItems);
    setCurrentPage(detailProduct.data.meta.currentPage);
    setLoading(false);
  };

  useEffect(() => {
    if (!product.hasOwnProperty('updated_at')) {
      getDetail();
    }
    getPagination(productId, 1, sort);
  }, [sort]);

  return (
    <>
      <BreadcrumbList listBreadcrumb={breadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '100vh',
            background: 'none'
          }}
        >
          <div className="header-detail">
            <div className="detail">
              <p>적재 위치</p>
              {(product?.inventory?.location || []).map((item:any)=>(
                <Text keyboard>{item ?? ''}</Text>
              ))
              }
            </div>
          </div>
          <div
            className=""
            style={{
              minHeight: '100vh',
              backgroundColor: 'white',
              padding: '30px 10px',
              borderRadius: '6px'
            }}
          >
            <div style={{ marginBottom: '0.5rem', padding: '0rem 1rem' }}>
              <InfoProduct info={info} />
            </div>
            {!!product.productName && (
              <DetailsPro
                img={product?.image?.url}
                productName={product.productName}
                width={product.width}
                height={product.height}
                length={product.length}
                demensionUnit={product.demensionUnit}
                weight={product.weight}
                weightUnit={product.weightUnit}
                estimateQuantity={product.estimateQuantity}
                averageMonthSale={product.averageMonthSale}
                sku={product.sku}
                eanUpc={product.eanUpc}
                asin={product.asin}
                packedMethod={product.packedMethod}
                storageMethod={product.storageMethod}
                dangerousGoods={product.dangerousGoods === true ? 'Yes' : 'No'}
                lotProduct={
                  product.lotProduct.charAt(0).toUpperCase() +
                  product.lotProduct.slice(1)
                }
              />
            )}
            <Table
              loading={loading}
              columns={columns}
              dataSource={list}
              pagination={{
                total: totalItems,
                current: currentPage,
                showSizeChanger: false,
                pageSize: 5,
                onChange: (page, limit) => {
                  getPagination(productId, page, sort);
                }
              }}
            />
            <div className="container-tag-button">
              <div className="tag-button">
                <div className="button-container">
                  <Button
                    type="default"
                    onClick={() => {
                      history.push({
                        pathname: `/admin/seller/request`,
                        state: {
                          idStock: productId,
                          stockName: product.productName
                        }
                      });
                    }}
                  >
                    반환 요청
                  </Button>
                </div>
                <div className="button-container">
                  <Button
                    className="renueProduct"
                    onClick={() => {
                      history.push({
                        pathname: `/admin/seller/request`,
                        state: {
                          idStock: productId,
                          stockName: product.productName
                        }
                      });
                    }}
                    style={{display: 'inline'}}
                  >
                    폐기 요청
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};
export default StockDetail;
